/**
 * list = 导出数据
 * name = 导出数据表名称
 */
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import XLSXStyle from 'xlsx-style';
const exportExcel = {
    exportExcel(List, name) {
         var wopts = {
            bookType: 'xlsx',
            bookSST: false,
            type: 'binary'
        };
        var workBook = {
            SheetNames: ['Sheet1'],
            Sheets: {},
            Props: {},
        };

        workBook.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(List);
        let rowhe = []
        for (const key in workBook.Sheets['Sheet1']) {
        if (key.indexOf("!") === -1 && workBook.Sheets['Sheet1'][key].v) {
            workBook.Sheets['Sheet1'][key].s = {
                font: {
                    //字体设置
                    name: "宋体",
                    sz: 12,
                    bold: false,
                  },
                  alignment: {
                    //文字居中
                    horizontal: "center",
                    vertical: "center",
                    wrap_text: true,
                  },
               }
           rowhe[key] = { hpx: 120 }
        }
        }
      let arr = []
       for (let index = 0; index < 8; index++) {

         arr[index] = { wpx: 150 }
       }
       workBook.Sheets['Sheet1']['!cols'] = arr
       workBook.Sheets['Sheet1']['!cols'][7] = { wpx: 200 }
       workBook.Sheets['Sheet1']["!rows"] = rowhe;
        let excelName = name + '.xlsx'
        FileSaver.saveAs(new Blob([exportExcel.changeData(XLSXStyle.write(workBook, wopts))], {
            type: 'application/octet-stream'
        }), excelName)
    },
    changeData(s) {
        if (typeof ArrayBuffer !== 'undefined') {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        } else {
            var buf = new Array(s.length);
            for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
            return buf;
        }
    },
}
export default exportExcel